import { useQuery } from '@tanstack/react-query';
import auth from '~/auth';

import { TAG_TYPE_CAMPAIGN, TAG_TYPE_HOLIDAY } from '~/consts/tags';

import OffersService from '~/services/OffersService';

import ApiError from '~/types/ApiError';

function sortTags(tags: Array<App.MarketingTag>) {
  return [...tags].sort((tagA, tagB) => tagA.name.localeCompare(tagB.name));
}

async function fetchMarketingTagsCatalog() {
  const [campaignsRes, holidayTypesRes] = await Promise.all([
    OffersService.getTags(TAG_TYPE_CAMPAIGN),
    OffersService.getTags(TAG_TYPE_HOLIDAY),
  ]);

  return {
    campaigns: sortTags(campaignsRes.result),
    holidayTypes: sortTags(holidayTypesRes.result),
  };
}

export function useMarketingTagsCatalog({ enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: ['marketing', 'tags-catalog'],
    queryFn: fetchMarketingTagsCatalog,
    enabled,
    staleTime: 60 * 1000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 401 && failureCount < 2) {
        void auth.getFreshAccessToken();
        return true;
      }

      return failureCount < 1;
    },
  });
}
